// /agent → the v3 Agent Desk (the user's agentic Robinhood account, mirrored
// from Supabase), reached from the More sheet. Thin shim like the other
// v2/pages screens.
import { AgentDesk } from '@/v2/v3/AgentDesk'

export function V2AgentDeskPage() {
  return <AgentDesk />
}
